// @flow
import React, { Component } from 'react';
import find from 'lodash/find';
import { withStyles } from '@material-ui/core/styles';
import { grey, blue, red, yellow } from '@material-ui/core/colors';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import AddIcon from '@material-ui/icons/Add';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import DeleteIcon from '@material-ui/icons/Delete';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';

import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import { Accordion, AccordionSummary, AccordionDetails, RootRef } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';

import Drawer from './Drawer';
import NotificationListItem from "./NotificationListItem";

import {
    Notification as NotificationType,
    Templates as TemplatesType,
    Template as TemplateType,
} from './types';


const styles = theme => ({
    notifications: {
        paddingTop: theme.spacing(1.5),
        paddingBotton: theme.spacing(1.5),
    },
    header: {
        paddingTop: theme.spacing(3),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        fontSize: 16,
    },
    button: {
        paddingLeft: theme.spacing(2),
        paddingBottom: theme.spacing(2)
    },
    buttonHeader: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        borderBottom: `1px solid ${grey[200]}`,
    },
    content: {
        paddingTop: theme.spacing(1),
        paddingRight: theme.spacing(2),
        paddingBottom: theme.spacing(1),
        paddingLeft: theme.spacing(2),
    },
    previewContent: {
        marginTop: theme.spacing(2),
        padding: theme.spacing(2),
        backgroundColor: grey[100],
    },
    previewLabel: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        color: grey[500],
        fontSize: 12,
    },
    previewDescription: {
        fontSize: 14,
        paddingRight: theme.spacing(2),
    },
    addButton: {
        textTransform: 'inherit',
        fontSize: 16,
        color: grey[700],
        fontWeight: 'normal',
        justifyContent: 'left',
        borderRadius: 20,
        width: '100%',
        '& svg': {
            marginRight: theme.spacing(2),
            fill: blue[500],
        },
    },
    templateSelect: {
        fontSize: 14,
    },
    menuItem: {
        fontSize: 14,
    },
    customNotesInput: {
        fontSize: 14,
    },
});

type Props = {
    sketchOrderId: Number,
    sketchOrderGroup: Object,
    templates: TemplatesType,
    selectedTemplate: TemplateType,
    notifications: Array<NotificationType>,
    notification: NotificationType,
    drawerMode: 'list' | 'new',
    onAddNotificationButtonClick: Function,
    onDeleteButtonClick: Function,
    onBackButtonClick: Function,
    onTemplateChange: Function,
    onCustomNotesChange: Function,
    classes: {
        header: string,
        buttonHeader: string,
        content: string,
        previewContent: string,
        previewLabel: string,
        previewDescription: string,
        addButton: string,
        templateSelect: string,
        menuItem: string,
        customNotesInput: string,
    },
};

type State = {
    template: TemplatesType,
};

class SketchOrderNotificationsDrawer extends Component<Props, State> {
    static defaultProps = {
        template: null,
    };
    templateSelect = null;
    constructor(props) {
        super(props);
        this.templateSelect = React.createRef();
        this.state = {
            template: null,
        };
    }
    componentDidUpdate(prevProps): void {
        if (prevProps.notification && !this.props.notification) {
            this.clearTemplate();
        }
    }
    clearTemplate = () => {
        this.setState({
            template: null,
        });
    };
    handleTemplateChange = (e) => {
        const id = e.target.value;
        const template = find(this.props.templates, ['id', id]);
        this.setState({
            template,
        });
        this.props.onTemplateChange(id)
    };
    render() {
        const { classes, notification } = this.props;
        const isEditing = notification && notification.id;
        const template = isEditing ? notification.template : this.state.template;
        return (
            <React.Fragment>
                <Drawer open={true}>
                    <Accordion className={classes.notifications} expanded={true}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Typography className={classes.header}>Order notifications</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <div>
                            <div className={classes.content}>
                                    <Button
                                        className={classes.addButton}
                                        onClick={this.props.onAddNotificationButtonClick}
                                    >
                                        <AddIcon />
                                        Add notification
                                    </Button>
                                </div>
                                <List>
                                    {this.props.notifications.map(notification => (
                                        <NotificationListItem
                                            id={notification.id}
                                            key={notification.id}
                                            priorityLevel={notification.template.priorityLevel}
                                            label={notification.template.label}
                                            acknowledged={notification.isAcknowledged}
                                            onClick={this.props.onAddNotificationButtonClick}
                                        />
                                    ))}
                                </List>
                            </div>
                        </AccordionDetails>
                    </Accordion>
                    {this.props.sketchOrderGroup && this.props.sketchOrderGroup.mapMarkerPoints.length > 1 ? <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Typography className={classes.header}>Orders in this group</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <div className={classes.button}>
                                {this.props.sketchOrderGroup && this.props.sketchOrderGroup.mapMarkerPoints.sort((a, b)=>a.ordinal-b.ordinal).map((m, index) => {
                                    return (
                                        <Button
                                            color="secondary"
                                        >
                                            <a href={`/orders/${m.sketchOrderId}`}>
                                                {m.ordinal}{m.sketchOrderId === this.props.sketchOrderId ? "*:" : ":"} Order #{m.sketchOrderId}
                                            </a>
                                        </Button>
                                    );
                                })}
                            </div>
                        </AccordionDetails>
                    </Accordion> : null}
                </Drawer>
                <Drawer open={this.props.drawerMode === 'new'}>
                    <div className={classes.buttonHeader}>
                        <Grid container>
                            <Grid item xs>
                                <IconButton
                                    size="small"
                                    onClick={this.props.onBackButtonClick}
                                >
                                    <ArrowBackIcon />
                                </IconButton>
                            </Grid>
                            <Grid item>
                                {isEditing &&
                                    <IconButton
                                        size="small"
                                        onClick={this.props.onDeleteButtonClick}
                                    >
                                        <DeleteIcon />
                                    </IconButton>
                                }
                            </Grid>
                        </Grid>
                    </div>
                    <div className={classes.content}>
                        <FormControl
                            fullWidth
                            disabled={!!isEditing}
                        >
                            <InputLabel htmlFor="template">Notification template</InputLabel>
                            <Select
                                className={classes.templateSelect}
                                ref={this.templateSelect}
                                value={this.props.notification ? this.props.notification.notificationTemplateId : -1}
                                onChange={this.handleTemplateChange}
                                inputProps={{
                                    name: 'template',
                                    id: 'template',
                                }}
                                MenuProps={{
                                    onEntered: this.handleTemplatesMenuEntered,
                                    onExited: this.handleTemplatesMenuExited,
                                }}

                            >
                                <MenuItem
                                    key={-1}
                                    value={-1}
                                    className={classes.menuItem}
                                >
                                    Select template
                                </MenuItem>
                                {
                                    this.props.templates.map((template) => (
                                        <MenuItem
                                            key={template.id}
                                            value={template.id}
                                            className={classes.menuItem}
                                        >
                                            {template.label}
                                        </MenuItem>
                                    ))
                                }
                                {/* If we're editing a notification, ensure the template displays in case it hasn't been retrieved yet */}
                                {
                                    this.props.notification && this.props.notification.template &&
                                    <MenuItem
                                        key={this.props.notification.template.id}
                                        value={this.props.notification.template.id}
                                        className={classes.menuItem}
                                    >
                                        <em>{this.props.notification.template.label}</em>
                                    </MenuItem>
                                }
                            </Select>
                        </FormControl>
                    </div>
                    {
                        template &&
                        <div className={classes.previewContent}>
                            <Typography className={classes.previewLabel}>Template preview</Typography>
                            <Typography className={classes.previewDescription}>{template.description}</Typography>
                        </div>
                    }
                    <div className={classes.content}>
                        <TextField
                            InputLabelProps={{
                                shrink: true,
                            }}
                            InputProps={{
                                classes: {
                                    input: classes.customNotesInput,
                                },
                            }}
                            id="custom-notes"
                            label="Additional notes"
                            placeholder="Enter custom notes"
                            multiline
                            margin="normal"
                            onChange={this.props.onCustomNotesChange}
                            value={this.props.notification ? this.props.notification.customNotes : ''}
                            fullWidth
                        />
                    </div>
                </Drawer>
            </React.Fragment>

        );
    }
};

export default withStyles(styles)(SketchOrderNotificationsDrawer);
